import { Video, Radio, AlertTriangle } from "lucide-react";
import { useEffect, useState } from "react";

const CountdownBanner = () => {
  const [variant, setVariant] = useState<string | null>(null);

  useEffect(() => {
    try {
      setVariant(localStorage.getItem("ab_variant_hero_headline"));
    } catch {
      // ignore
    }
  }, []);

  const isCD = variant === "C" || variant === "D";

  const baseChip = "flex items-center gap-1.5 px-3 py-1 rounded-full border";
  const defaultChip = "border-primary/40 bg-primary/10 text-primary";

  return (
    <div className="w-full bg-background py-2.5 text-center">
      <div className="flex items-center justify-center gap-2 md:gap-3 text-xs md:text-sm font-bold uppercase tracking-wider">
        <span
          className={`${baseChip} border-[hsl(210_90%_55%)]/50 bg-[hsl(210_90%_55%)]/10 text-[hsl(210_90%_60%)]`}
        >
          <Video className="w-3.5 h-3.5" /> Zoom
        </span>
        <span
          className={`${baseChip} border-white/40 bg-white/10 text-white`}
        >
          <Radio className="w-3.5 h-3.5" /> Ao vivo
        </span>
        <span
          className={`${baseChip} ${
            isCD
              ? "border-foreground/40 bg-foreground/10 text-foreground"
              : "border-red-600/60 bg-red-600/15 text-red-500"
          }`}
        >
          <AlertTriangle className="w-3.5 h-3.5" /> SÁBADO, 25/07
        </span>
      </div>
    </div>
  );
};

export default CountdownBanner;
